module.exports = __webpack_public_path__ + "static/img/7.0d972bd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/7/zh/7.png
// module id = RdCt
// module chunks = 0